"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDimensionsClass = void 0;
const ua_parser_js_1 = require("ua-parser-js");
const loggingTypes_1 = require("../types/loggingTypes");
const sendLoggingEvent_1 = require("./sendLoggingEvent");
const helpers_1 = require("../../../helpers");
const constants_1 = require("../../../constants");
const auth_1 = __importDefault(require("../../../auth"));
class CustomDimensionsClass {
    constructor(currentScreen) {
        this.setPreviousWidget = (currentWidget) => {
            currentWidget
                && (0, helpers_1.setCookie)(constants_1.CookiesConstants.PREVIOUS_LOGGING_WIDGET, currentWidget);
        };
        this.setPreviousActions = (currentActions) => {
            (0, helpers_1.setCookie)(constants_1.CookiesConstants.PREVIOUS_LOGGING_ACTIONS, JSON.stringify(currentActions));
        };
        this.getPreviousWidget = () => {
            const previousWidgetName = CustomDimensionsClass.cookies[constants_1.CookiesConstants.PREVIOUS_LOGGING_WIDGET];
            return !previousWidgetName ? "NA" : previousWidgetName;
        };
        this.getPreviousActions = () => {
            let previousActions = (0, helpers_1.jsonSafeGet)(CustomDimensionsClass.cookies[constants_1.CookiesConstants.PREVIOUS_LOGGING_ACTIONS], {});
            if (previousActions) {
                const { L1, L2, L3 } = previousActions;
                return { L1, L2, L3 };
            }
            return { L1: "NA", L2: "NA", L3: "NA" };
        };
        this.currentScreen = currentScreen;
    }
    static getInstance(currentScreen) {
        if (!CustomDimensionsClass.instance) {
            CustomDimensionsClass.instance = new CustomDimensionsClass(currentScreen);
            CustomDimensionsClass.sessionCookies = (0, helpers_1.parseCookies)();
        }
        CustomDimensionsClass.cookies = (0, helpers_1.parseCookies)();
        return CustomDimensionsClass.instance;
    }
    getDeviceDetails() {
        var _a, _b, _c;
        let ua = helpers_1.isBrowser && new ua_parser_js_1.UAParser(navigator.userAgent);
        const browserName = ua.getBrowser().name || sendLoggingEvent_1.DEFAULT_VALUE;
        const browserVersion = ua.getBrowser().version || sendLoggingEvent_1.DEFAULT_VALUE;
        const deviceBrand = ua.getDevice().vendor || sendLoggingEvent_1.DEFAULT_VALUE;
        const deviceModel = ua.getDevice().model || sendLoggingEvent_1.DEFAULT_VALUE;
        const deviceCpuArch = ua.getCPU().architecture || sendLoggingEvent_1.DEFAULT_VALUE;
        const deviceLanguage = (_c = (helpers_1.isBrowser && ((_b = (_a = navigator.language) === null || _a === void 0 ? void 0 : _a.split("-")) === null || _b === void 0 ? void 0 : _b[0]))) !== null && _c !== void 0 ? _c : sendLoggingEvent_1.DEFAULT_VALUE;
        const deviceOS = ua.getOS().name || sendLoggingEvent_1.DEFAULT_VALUE;
        const deviceOSVersion = ua.getOS().version || sendLoggingEvent_1.DEFAULT_VALUE;
        const now = new Date();
        const timeZoneOffset = now.getTimezoneOffset();
        const hoursOffset = Math.abs(Math.floor(timeZoneOffset / 60));
        const minutesOffset = Math.abs(timeZoneOffset % 60);
        const sign = timeZoneOffset >= 0 ? "-" : "+";
        const deviceTimeZone = `UTC${sign}${hoursOffset.toString().padStart(2, "0")}:${minutesOffset
            .toString()
            .padStart(2, "0")}` || sendLoggingEvent_1.DEFAULT_VALUE;
        return {
            browserName,
            browserVersion,
            deviceBrand,
            deviceModel,
            deviceCpuArch,
            deviceLanguage,
            deviceOS,
            deviceOSVersion,
            deviceTimeZone,
        };
    }
    getConnectionInfo() {
        const { effectiveType } = navigator === null || navigator === void 0 ? void 0 : navigator['connection'];
        const { rtt } = navigator === null || navigator === void 0 ? void 0 : navigator['connection'];
        const connectionType = effectiveType || sendLoggingEvent_1.DEFAULT_VALUE;
        const connectionLatency = rtt || sendLoggingEvent_1.DEFAULT_VALUE;
        return { connectionType, connectionLatency };
    }
    getHttpReferrer() {
        const httpReferrer = (helpers_1.isBrowser && document.referrer) || sendLoggingEvent_1.DEFAULT_VALUE;
        return httpReferrer;
    }
    getDeviceUserAgent() {
        return (helpers_1.isBrowser && navigator.userAgent) || sendLoggingEvent_1.DEFAULT_VALUE;
    }
    getScreenResolution() {
        return ((helpers_1.isBrowser && `${window.screen.width}x${window.screen.height}`) ||
            sendLoggingEvent_1.DEFAULT_VALUE);
    }
    getSessionDetails() {
        var _a, _b, _c, _d, _e;
        const cookies = CustomDimensionsClass.sessionCookies;
        const source = cookies["source"] === "desktop" ? "web_desktop" : "web_mobile";
        const sessionId = (_b = (_a = (0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.SESSION], {})) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "NA";
        const trackingId = (_c = cookies[constants_1.CookiesConstants.DEVICE_UUID]) !== null && _c !== void 0 ? _c : "NA";
        const userInfo = auth_1.default.getInstance().identity;
        const sessionStarted = (_d = (0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.SESSION], {})) === null || _d === void 0 ? void 0 : _d.startedAt;
        let currentTime = new Date().getTime();
        let sessionLife;
        if (sessionStarted) {
            sessionLife = Math.floor((currentTime - sessionStarted) / 1000);
        }
        else {
            const tgtTimeStamp = Number((0, helpers_1.jsonSafeGet)(cookies[constants_1.CookiesConstants.AUTH_V2], {}).t);
            sessionLife = Math.floor(currentTime / 1000 - tgtTimeStamp);
        }
        const postCountry = (_e = cookies[constants_1.CookiesConstants.COUNTRY]) !== null && _e !== void 0 ? _e : "xx";
        return {
            source,
            sessionId,
            trackingId,
            userInfo,
            sessionLife,
            postCountry,
        };
    }
    getUtms() {
        const query = new URLSearchParams(window.location.search);
        const utmMedium = (query === null || query === void 0 ? void 0 : query.get("utm_medium"))
            ? query === null || query === void 0 ? void 0 : query.get("utm_medium")
            : sendLoggingEvent_1.DEFAULT_VALUE;
        const utmCampaign = (query === null || query === void 0 ? void 0 : query.get("utm_campaign"))
            ? query === null || query === void 0 ? void 0 : query.get("utm_campaign")
            : sendLoggingEvent_1.DEFAULT_VALUE;
        const utmSource = (query === null || query === void 0 ? void 0 : query.get("utm_source"))
            ? query === null || query === void 0 ? void 0 : query.get("utm_source")
            : sendLoggingEvent_1.DEFAULT_VALUE;
        return { utmMedium, utmCampaign, utmSource };
    }
    getClickStreamSearchID() {
        if (helpers_1.isBrowser)
            return localStorage.getItem(constants_1.LocalStorageConstants.SEARCH_ID);
    }
    setSessionFunnelSource(screen) {
        if (screen) {
            this.sessionFunnelSource = screen;
            return;
        }
        else
            this.sessionFunnelSource = loggingTypes_1.EnumLoggingScreenNames.NA;
    }
    getSessionFunnelSource() {
        return this.sessionFunnelSource;
    }
}
exports.CustomDimensionsClass = CustomDimensionsClass;
